import * as React from "react"

import { AppProvider } from "@toolpad/core/AppProvider"
import { DashboardLayout } from "@toolpad/core/DashboardLayout"
import { PageContainer } from "@toolpad/core/PageContainer"
import { theme } from "../../theme"
// import Navigate from "./Navigate"
import RealEstateAgentIcon from "@mui/icons-material/RealEstateAgent"
import { getToken, getUserFromToken, removeToken } from "../../utils/token"
import { Avatar } from "@mui/material"
import ToolbarActionsSearch from "./ToolbarActionsSearch"
import { Outlet } from "react-router-dom"
import useFilteredNavigate from "./Navigate"



export default function SideBar(props) {
  const { window } = props

  const [session, setSession] = React.useState(null)

  function stringToColor(string) {
    let hash = 0
    let i

    /* eslint-disable no-bitwise */
    for (i = 0; i < string?.length; i += 1) {
      hash = string?.charCodeAt(i) + ((hash << 5) - hash)
    }

    let color = "#"

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff
      color += `00${value.toString(16)}`.slice(-2)
    }
    /* eslint-enable no-bitwise */

    return color
  }
  function stringAvatar(name) {
    return {
      sx: {
        bgcolor: stringToColor(name)
      },
      children: `${name?.split(" ")[0][0]}${name?.split(" ")[1][0]}`
    }
  }

  React.useEffect(() => {
    const token = getToken()
    const user = getUserFromToken(token)
    console.warn(user)
    if (user) {
      setSession({
        user: {
          name: user.userName,
          email: user.email,
          image: <Avatar {...stringAvatar(user.name)} />
        }
      })
    }
  }, [])

  const authentication = React.useMemo(() => {
    return {
      signIn: () => {},
      signOut: () => {
        removeToken()
        // window.location.reload()
      }
    }
  }, [])


  // Remove this const when copying and pasting into your project.
  const demoWindow = window ? window() : undefined

  const dynamicNavigation = useFilteredNavigate();

  return (
    <AppProvider
      session={session}
      authentication={authentication}
      navigation={dynamicNavigation}
      branding={{
        logo: <RealEstateAgentIcon color="primary" />,
        title: "KFD",
        homeUrl: "/dashboard"
      }}
      theme={theme}
      window={demoWindow}
    >
      <DashboardLayout
        defaultSidebarCollapsed
        slots={{
          // appTitle: CustomAppTitle,
          toolbarActions: ToolbarActionsSearch
          // sidebarFooter: SidebarFooter,
        }}
      >
        {/* <PageContainer></PageContainer> */}
        <Outlet />
      </DashboardLayout>
    </AppProvider>
  )
}
